<div class="d-flex">
    <div class="col-4 pl-0 pr-0 phone-picker">
        <ng-select [items]="countryCodes | async" [formControl]="formControl.get(codeKey)" [formlyAttributes]="field"
            bindLabel="display_name" bindValue="dial_code" [required]="to.required">
            <ng-template ng-label-tmp let-item="item">
                <span class="flag flag-{{item.icon}}"></span>
                <span>{{item.dial_code}}</span>
            </ng-template>
        </ng-select>
    </div>
    <div class="col-8 pl-0 d-flex flex-column">
        <input class="form-control form-control-sm"
            [ngClass]="{ 'is-invalid':phNumberControl.invalid && phNumberControl.touched }" [required]="to.required"
            [formControl]="formControl.get(phoneKey)" [formlyAttributes]="field">
        <div *ngIf="phNumberControl.invalid && phNumberControl.touched" class="invalid-feedback flex-grow">
            <div *ngIf="formControl.get(phoneKey).invalid">This field is required</div>
        </div>
    </div>
</div>